import * as firebase from 'firebase';
import { config } from '../config/firebase'
require("firebase/firestore");

if (!firebase.apps.length) {
  firebase.initializeApp(config);
}

export {
  firebase
};




// WEBPACK FOOTER //
// ./src/firebase/init.js